let _config = null;

export function setConfig(config) {
  _config = config;
}

export function getConfig() {
  if (!_config) {
    throw new Error('Drive module not initialized');
  }
  return _config;
}
